<template>
  <div>
    <base-info
      ref="baseInfo"
      v-model="form"
      v-loading="loading"
      :form-tax-rate="formTaxRate"
      :base-international-data="baseInternationalData"
      @shippingChange="handleShippingChange"
    />
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        合同附件信息
      </div>
      <div class="rj-page-card__content">
        <contract-file v-if="form.id" :contract-num="form.id" :contract-type="this.form.contractType" />
      </div>
    </div>
    <rejected-list ref="rejectedList" v-loading="rejectedLoading" />

    <!--国际服务独立销售订单: 需要展示的收货信息组件,if: 1 为国际服务独立销售单据-->
    <product-server-list
      v-if="isShowInternationalServiceOrders===1"
      ref="product"
      :is-test-project="form.isTestProject"
      :rebate-amount="form.rebateAmount"
      :sales-type="form.salesType"
      :rebate="form.rebate"
      :contract-type="form.contractType"
      :form="form"
      @chooseAddress="
        val => {
          form.receiptAddressId = val.id;
        }
      "
      @change="handleShippingChange"
    />
    <product-list
      v-else
      ref="product"
      :is-test-project="form.isTestProject"
      :rebate-amount="form.rebateAmount"
      :sales-type="form.salesType"
      :rebate="form.rebate"
      :contract-type="form.contractType"
      :form="form"
      :contract-code="contractNum"
      @chooseAddress="
        val => {
          form.receiptAddressId = val.id;
        }
      "
      @change="handleShippingChange"
    />

    <abatement-reminder v-model="form" :distributor-participate="form.distributorParticipate" :integrator-participate="form.integratorParticipate" />
    <dismissed-suggestion
      v-if="form.id"
      ref="rejected"
      :contract-id="form.id"
    />

    <actions
      :agent-id="form.agentId"
      :is-distribution="isDistribution"
      :is-new-contract="form.isNewContract"
      :as-inter-direct="form.asInterDirect"
    />
  </div>
</template>
<script type="es6">
import actions from './actions';
import actionMixin from './actionMixin';
import dismissedSuggestion from '../dismissedSuggestion';
import baseInfo from './baseInfo';
import productList from '../internationalProductList';
import productServerList from '../internationalServerProductList';
import rejectedList from '../rejectedList';
import contractFile from '../../../Chief/contract/common/contractFile';
import abatementReminder from '../../../contractCommonInput/internationalAbatementReminder';
import axios, {
  getContractDetailAllInfoByConNum,
  getContractProductInfoByContractId,
  getReceiptAddressByContractId,
  getRejectedList,
  paymentRatioCheck
} from '@/API';
import { getCalculateInterSettlementAmountV2 } from '@/API/international';
export default {
  mixins: [actionMixin],
  data () {
    return {
      form: {
        id: null
      },
      loading: false,
      rejectedLoading: false,
      formTaxRate: '',
      isDistribution: false,
      baseInternationalData: {
        advanceCharge: 0,
        prepaymentRatioNum: 0
      },
      isShowInternationalServiceOrders: 0 // 是否是国际服务订单,用户控制baseInfo组件中的电源线规则是否显示
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    baseInfo,
    productList,
    actions,
    contractFile,
    dismissedSuggestion,
    rejectedList,
    abatementReminder,
    productServerList
  },
  computed: {},
  methods: {
    handleShippingChange () {
      // soldCountry
      // rebate
      // orderSales
      const baseInfo = this.$refs.baseInfo.form;
      const product = this.$refs.product;
      const productVOList = [];
      product && product.productList.forEach((item) => {
        if (item) {
          productVOList.push({
            id: item.id,
            settlementAmount: item.settlementAmount,
            productCode: item.productCode,
            productPriceSigle: item.productPriceSigle,
            productNum: item.productNum,
            serviceLife: item.serviceLife // 产品行服务年限
          });
        }
      });
      const params = {
        contractId: baseInfo.id,
        modeOfShipping: baseInfo.modeOfShipping,
        isRebate: baseInfo.isRebate,
        rebateAmount: baseInfo.isRebate ? baseInfo.rebateAmount : 0,
        productVOList: productVOList,
        orderUnitName: baseInfo.orderUnit,
        salesType: baseInfo.salesType,
        supplyUnitId: baseInfo.supplyUnitId,
        communicationOrderDiscount: baseInfo.communicationOrderDiscount,
        tradeTerm: baseInfo.tradeTerm,
        rebate: baseInfo.rebate,
        orderSales: baseInfo.orderSales,
        overSeasSalesCountry: baseInfo.soldCountry,
        orderType: baseInfo.contractType,
        // 国际服务独立销售,重新计算最终实际结算金额需要传入的字段,目前写死,因为后端需要根据这个字段,来走固定的判断计算逻辑
        systemSource: this.isShowInternationalServiceOrders === 1 ? 'ORDENSINTERNACIONAISSERVICOS' : ''
      };
      this.getCalculateInterSettlementAmountV2(params);
    },
    getCalculateInterSettlementAmountV2 (params) {
      const product = this.$refs.product;
      getCalculateInterSettlementAmountV2(params).then((res) => {
        const json = res.data;
        this.formTaxRate = json.data.formTaxRate;
        if (json.status === '200') {
          let _productList = product.productList;
          _productList.forEach((i) => {
            json.data.productVOList.forEach((j) => {
              // 产品单价、销售代码、数量一致
              if (i.productPriceSigle === j.productPriceSigle && i.productCode === j.productCode && i.productNum === j.productNum) {
                i.settlementAmount = j.settlementAmount;
              }
            });
          });
          // 运输方式是否有运费
          if (json.data.freightFlag) {
            let freightInfo = _productList.find(item => item.productName === 'Freight');
            // 产品行中是否有运费，有则更新，没有则添加
            if (freightInfo !== undefined) {
            // freightInfo = { ...json.data.freightProduct };
              this.$set(freightInfo, 'productPriceSigle', json.data.freightProduct.productPriceSigle);
              this.$set(freightInfo, 'settlementAmount', json.data.freightProduct.settlementAmount);
              this.$set(freightInfo, 'orderAmount', json.data.freightProduct.orderAmount);
              this.$set(freightInfo, 'beforeSplitProductPriceSigle', json.data.freightProduct.beforeSplitProductPriceSigle);
            } else {
              _productList.push(json.data.freightProduct);
            }
          } else {
            let freightInfoIndex = _productList.findIndex(item => item.productName === 'Freight');
            // 删除已存在的运费
            if (freightInfoIndex !== -1) {
              delete _productList.splice(freightInfoIndex, 1);
            }
          }
        }
      }).catch((res) => {

      });
    },
    initData () {
      this.loading = true;
      getContractDetailAllInfoByConNum(this.contractNum).then((res) => {
        this.loading = false;
        const json = res.data;
        if (json.status === '200') {
          this.form = json.data;
          this.isDistribution = this.form.contractType === '国际分销下单';
          this.$nextTick(() => {
            this.$refs.baseInfo.setInitData();
            this.initProduct();
            this.initRejected(json.data.id);
            this.GetPaymentRatioCheck(json.data.id);
          });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    // 获取预付款金额比例
    GetPaymentRatioCheck (contractIdParams) {
      let contractId = {
        contractId: contractIdParams
      };
      paymentRatioCheck(contractId).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.baseInternationalData.advanceCharge = json.data.advanceCharge;
          this.baseInternationalData.prepaymentRatioNum = json.data.prepaymentRatioNum;
        }
      }).catch((res) => {
      });
    },
    initProduct () {
      this.productLoading = true;
      axios.all([
        getContractProductInfoByContractId(this.form.id),
        getReceiptAddressByContractId(this.form.id)
      ]).then((res) => {
        const fjson = res[0].data;
        const sjson = res[1].data;
        this.productLoading = false;
        if (fjson.status === '200') {
          if (this.form.contractType === '国际分销下单' && fjson.data) {
            if (fjson.data[0].orderProductId === null && !fjson.data[0].serviceDesc) {
              this.$refs.product.productList = fjson.data;
            } else {
              let productList = [];
              let zeroList = [];
              fjson.data.forEach(item => {
                if (item.orderProductId) {
                  productList.push(item);
                  let l1Arr = [];
                  let l2Arr = [];
                  fjson.data.forEach(one => {
                    if (Number(one.serviceKeyList) === item.orderProductId && one.orderAmount) {
                      if (one.serviceLevel === 1) {
                        l1Arr.push(one);
                      } else if (one.serviceLevel === 2) {
                        l2Arr.push(one);
                      } else {
                        productList.push(one);
                      }
                    }
                  });
                  productList = [...productList, ...l1Arr, ...l2Arr];
                } else if (!item.orderAmount) {
                  zeroList.push(item);
                }
              });
              const merged = Array.from(
                zeroList.reduce((map, item) => {
                  const { productName } = item;
                  const existing = map.get(productName);
                  if (existing) {
                    existing.productNum += item.productNum;
                  } else {
                    map.set(productName, { ...item });
                  }
                  return map;
                }, new Map())
              ).map(([_, value]) => value);
              this.$refs.product.productList = [...productList, ...merged];
            }
          } else {
            this.$refs.product.productList = fjson.data;
          }

          this.handleShippingChange();
          // 让表格重新计算高度，防止合计被fixed属性破坏宽度
          this.$nextTick(() => {
            if (fjson.data.length > 10) {
              this.$refs.product.tableHeight = 500;
            } else {
              this.$refs.product.tableHeight = '';
            }
          });
        }
        if (sjson.status === '200') {
          this.$refs.product.address = sjson.data;
        }
      }).catch(() => {
        this.productLoading = false;
      });
    },
    initRejected (contractId) {
      this.rejectedLoading = true;
      getRejectedList(contractId).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          this.$refs.rejectedList.rejectedList = json.data;
          this.rejectedLoading = false;
        }
      }).catch((res) => {
        this.rejectedLoading = false;
      });
    }
  },
  mounted () {
    this.initData();
    this.isShowInternationalServiceOrders = Number(this.$route.query.isShowInternationalService);
  }
};
</script>
<style lang="scss" scoped></style>
